<template>
  <div>
    <el-form :model="queryParamschat"
               ref="queryForm"
               size="small"
               :inline="true">
        <el-form-item label="请求内容"
                      prop="reqCon">
          <el-input v-model="queryParamschat.reqCon"
                    placeholder="请输入请求内容"
                    clearable
                    @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="响应内容"
                      prop="repCon">
          <el-input v-model="queryParamschat.repCon"
                    placeholder="请输入响应内容"
                    clearable
                    @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="mini"
                     @click="handleQueryChat">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-back"
                     size="mini"
                     @click="back">返回</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="messageList"
               >
        <el-table-column label="请求内容"
                         prop="RequestContent"
                         :show-overflow-tooltip="true" />
        <el-table-column label="App名称"
                         prop="AppName" />
        <el-table-column label="App用户姓名"
                         prop="AppUserName"
                         :show-overflow-tooltip="true" />
        <el-table-column label="请求开始时间"
                         prop="RequestStartTime"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.RequestStartTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="280"
                         align="center"
                         class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="text"
                       icon="el-icon-tickets"
                       @click="handleDetailMessage(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
import {  ChatMessageList } from '@/api/chatMessage'
import { parseTime } from '@/utils/parseTime'
export default {
  data(){
    return{
      messageList: [],
      queryParamschat:{}
    }
  },
  mounted(){
    this.loadData()
  },
  methods:{
    parseTime,
    loadData(){
      this.queryParamschat={ ...this.$route.query }
      this.handleQueryChat()
    },
    async handleQueryChat () {
      const [res, err] = await ChatMessageList({...this.queryParamschat})
      let rowData = res.data.Data
      this.messageList = rowData
    },
    back(){
      this.$router.go(-1)
    },
    handleDetailMessage(row){
      this.$router.push({path:'/sys/messageDetail', query:{...row} })
    },
  }
}
</script>

<style>

</style>